// extracted by mini-css-extract-plugin
module.exports = {"logoCircle":"LogoBubble__logoCircle____MG76"};